import React, { useEffect, useRef } from 'react';

function Signature() {
  const signatureElement = useRef(null);

  useEffect(() => {
    const delay = 0;

    const signature = signatureElement.current.querySelector('svg');
    const path = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );
    path.setAttribute('id', 'signature');
    path.setAttribute('d', 'M 0,50 L 0,0 L 50,25 L 100,0 L 100,50 L 100,0 L 101,0 L 150,50 L 200,0 L 250,0 L 250,50 L250,0 L 300,0');
    path.setAttribute('stroke', "url('#gradient-animate')");
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke-dashoffset', '915');
    path.setAttribute('stroke-dasharray', '915');
    path.innerHTML = `<animate begin="${delay}ms" attributeName="stroke-dashoffset" from="915" to="0" dur="5s" fill="freeze" calcMode="linear"/>`;
    signature.appendChild(path);

    const pen = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'polygon'
    );
    pen.setAttribute('points', '0,0 0,-3 7,-10 10,-7 3,0');
    pen.setAttribute('fill', 'none');
    pen.setAttribute('stroke', 'grey');
    pen.setAttribute('visibility', 'hidden')
    pen.innerHTML = `<animateMotion dur="3.3s" begin="${delay}ms" fill="freeze"><mpath xlink:href="#signature" calcMode="linear" /></animateMotion><set attributeName="visibility" from="hidden" to="visible" begin="${delay}ms"/>`;
    signature.appendChild(pen);

    const underline = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );
    underline.setAttribute('d', 'M -5,55 L 305,55');
    underline.setAttribute('stroke', 'rgb(170,170,170)');
    underline.setAttribute('fill', 'none');
    underline.setAttribute('stroke-dashoffset', '310');
    underline.setAttribute('stroke-dasharray', '310');
    underline.innerHTML = `<animate begin="${delay}ms" attributeName="stroke-dashoffset" from="310" to="0" dur="3.25s" fill="freeze" calcMode="linear"/>`;
    signature.appendChild(underline);
  }, []);


  return (
    <div className="SignatureWrapper" ref={signatureElement}>
      <svg width="100%" height="100%" viewBox="-10 -10 320 80">
        <defs>  
          <linearGradient id="gradient-animate" x1="100%" y1="50%" x2="0%" y2="50%"> 
            <stop offset="0%">
              <animate attributeName="stop-color" values="red; orange; yellow; green; blue; purple; red" dur="4s" repeatCount="indefinite" />
            </stop>
            <stop offset="20%">
              <animate attributeName="stop-color" values="orange; yellow; green; blue; purple; red; orange" dur="4s" repeatCount="indefinite" />
            </stop>
            <stop offset="40%">
              <animate attributeName="stop-color" values="yellow; green; blue; purple; red; orange; yellow" dur="4s" repeatCount="indefinite" />
            </stop>
            <stop offset="60%">
              <animate attributeName="stop-color" values="green; blue; purple; red; orange; yellow; green" dur="4s" repeatCount="indefinite" />
            </stop>
            <stop offset="80%">
              <animate attributeName="stop-color" values="blue; purple; red; orange; yellow; green; blue" dur="4s" repeatCount="indefinite" />
            </stop>
            <stop offset="100%">
              <animate attributeName="stop-color" values="purple; red; orange; yellow; green; blue; purple" dur="4s" repeatCount="indefinite" />
            </stop>
          </linearGradient> 
        </defs>
      </svg>
    </div>
  );
}

export default Signature;
